import React from "react";
// Note: ParticleBackground available at @/components/ParticleBackground if needed

export function DarkChapter({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative">
      {/* Unified dark background - premium neutral tones */}
      <div className="absolute inset-0 z-0">
        {/* Pure dark base */}
        <div className="absolute inset-0" style={{ backgroundColor: 'hsl(0, 0%, 3%)' }} />
        
        {/* Subtle warm gradient for depth */}
        <div 
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(ellipse 120% 80% at 50% 0%, rgba(30, 25, 22, 0.4) 0%, transparent 60%)'
          }}
        />
        
        {/* Film grain texture overlay */}
        <div 
          className="absolute inset-0 z-[1] opacity-[0.03] pointer-events-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
            mixBlendMode: 'overlay',
          }}
        />
        
        {/* Vignette for focus */}
        <div 
          className="absolute inset-0 z-[2]"
          style={{
            background: 'radial-gradient(ellipse 80% 70% at 50% 40%, transparent 0%, rgba(0,0,0,0.4) 100%)'
          }}
        />
        
        {/* Particle background removed - can be restored from @/components/ParticleBackground */}
      </div>
      
      {/* Content on top */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
